import {
  getQueueSessionCookieName
} from "./chunk-G2X2IF27.mjs";
import {
  ApiConfig
} from "./chunk-IITKCRXL.mjs";
import {
  __async,
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/client.ts
import { readCookie } from "@wbk/utils";
var QUEUE_SESSION_HEADER = "queue-token";
var defined = (override) => Object.fromEntries(
  Object.entries(override).filter(([, value]) => value !== void 0 && value !== "")
);
var resolveOverride = (id) => {
  var _a, _b, _c, _d, _e;
  if (!id) return {};
  const [domain, fn] = id.split(".");
  const scope = (_d = (_c = (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.overrides) == null ? void 0 : _c[domain]) != null ? _d : {};
  const domainLevel = defined(
    Object.fromEntries(
      Object.entries(scope).filter(([key, value]) => key === "headers" || typeof value !== "object")
    )
  );
  const slot = defined((_e = scope[fn]) != null ? _e : {});
  const headers = domainLevel.headers || slot.headers ? __spreadValues(__spreadValues({}, domainLevel.headers), slot.headers) : void 0;
  return __spreadValues(__spreadValues(__spreadValues({}, domainLevel), slot), headers && { headers });
};
var fetchClient = (props) => __async(null, null, function* () {
  var _b;
  const _a = resolveOverride(props.id), { headers: overrideHeaders } = _a, override = __objRest(_a, ["headers"]);
  const {
    baseUrl,
    url,
    options,
    raw,
    formData,
    includeAuth = true,
    includeToken = true,
    queue,
    version
  } = __spreadValues(__spreadValues({}, props), override);
  const wbkConfig = (_b = ApiConfig.config) == null ? void 0 : _b.wbk;
  if (!baseUrl && !wbkConfig) {
    const msg = "WBK `ApiConfig` was not initialized. See instructions in https://github.com/nadude/webook-frontend/blob/main/packages/api/README.md";
    console.error(msg);
    throw new Error(msg);
  }
  let api = wbkConfig == null ? void 0 : wbkConfig.api;
  if (version === "v1") {
    api = api == null ? void 0 : api.replace("/v2", "/v1");
  }
  const base = baseUrl || api;
  const endPoint = url.startsWith("/") ? url : `/${url}`;
  const token = readCookie("token") || "";
  const queueSession = queue ? readCookie(getQueueSessionCookieName(queue)) : "";
  const headers = __spreadValues(__spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadValues({}, includeToken && { token: wbkConfig == null ? void 0 : wbkConfig.apiToken }), includeAuth && { Authorization: `Bearer ${token}` }), queueSession && { [QUEUE_SESSION_HEADER]: queueSession }), {
    Accept: "application/json"
  }), options == null ? void 0 : options.headers), overrideHeaders);
  const response = yield fetch(`${base}${endPoint}`, __spreadProps(__spreadValues({}, options), {
    headers: formData ? headers : __spreadValues({ "Content-Type": "application/json" }, headers)
  }));
  if (raw) {
    return response;
  }
  const res = yield response.json();
  if (!response.ok) {
    if (!res.message) {
      res.message = (res == null ? void 0 : res.error) || "Something went wrong";
    }
    res.statusCode = response.status;
    throw res;
  }
  return res;
});

export {
  fetchClient
};
//# sourceMappingURL=chunk-64N4INLD.mjs.map